import { useContext, useEffect } from "react";
import { Grid } from "@material-ui/core";
import InputRadio from "../../../../../components/inputs/InputRadio";

import useProdutosBodyController from "../../controllers/ProdutosBodyController";
import SwitchesContainer from "../../commons/SwitchesContainer";
import { ProdutosBodyContext } from "../../contexts/ProdutosBodyContext";
import { GridSpacedItems, ParamsContent } from "../../styles/styles";
import { TabHeader } from "../../commons/TabHeader";

const TabGuias = () => {
  const { switchesGeneral, optionsBarcode } = useProdutosBodyController();

  const { barcodeType, setBarcodeType } = useContext(ProdutosBodyContext);

  useEffect(() => {
    switchesGeneral.forEach((el) => {
      if (el.disabled) el.setValue(false);
    });
  }, [switchesGeneral]);

  return (
    <>
      <TabHeader
        title="Parâmetros gerais dos Produtos"
        subtitle="Selecione os parâmetros gerais dos produtos."
      />

      <ParamsContent>
        {/* input será usado no futuro */}
        {/* <Grid item>
        <InputRadio
          label="Qtde. de casas decimais para os campos de valor"
          options={optionsZeros}
          row
          value={zerosQuantity}
          setValue={setZerosQuantity}
        />
      </Grid> */}

        <GridSpacedItems container>
          <Grid item xs={6}>
            <InputRadio
              label="Tipo de código de barras"
              options={optionsBarcode}
              row
              value={barcodeType}
              setValue={setBarcodeType}
            />
          </Grid>
          {switchesGeneral.map(({ ...props }) => (
            <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
              {/* testar <Grid container item alignItems="center" xs={6}> */}
              <SwitchesContainer {...props} />
            </Grid>
          ))}
        </GridSpacedItems>
      </ParamsContent>
    </>
  );
};

export default TabGuias;
